import axios from 'axios';
import { API_URL } from '../../config/system/systemConfig';
import { SearchesModel } from '../../models/platform/searchesModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import authHeader from '../../utils/authHeaderUtils';
import { handleAxiosError } from '../../utils/errorUtils';

class FdaApi {

    async get510kData(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/fda/510k`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async get510kDetail(search_execution_id: string, k_number: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                k_number,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post(`${API_URL}/api/data-sections/fda/510k/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getEnforcementsData(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/fda/enforcements`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getEnforcementDetail(search_execution_id: string, recall_number: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                recall_number,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post(`${API_URL}/api/data-sections/fda/enforcements/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getEventsData(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/fda/events`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getEventDetail(search_execution_id: string, mdr_report_key: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                mdr_report_key,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post(`${API_URL}/api/data-sections/fda/events/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getPmaData(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/fda/pma`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getPmaDetail(search_execution_id: string, pma_number: string, supplement_number: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                pma_number,
                supplement_number,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post(`${API_URL}/api/data-sections/fda/pma/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getRecallData(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/fda/recall`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getRecallDetail(search_execution_id: string, product_res_number: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                product_res_number,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post(`${API_URL}/api/data-sections/fda/recalls/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getRegistrationListingsData(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/fda/registrationlistings`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getRegistrationListingsDetail(search_execution_id: string, key_proprietary_name: string, key_product_code: string, key_registration_number: string, key_k_number: string, key_pma_number: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                key_proprietary_name,
                key_product_code,
                key_registration_number,
                key_k_number,
                key_pma_number,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post(`${API_URL}/api/data-sections/fda/registrationlistings/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

    async getUdiData(search_execution_id: string, search: SearchesModel) {
        try {
            const response = await axios.post(`${API_URL}/api/data-sections/fda/udi`, { search_execution_id, search },
                {
                    headers: authHeader(),
                });
            return response.data as ResponseSuccessModel;
        } catch (error) {
            throw error;
        }
    }

    async getUdiDetail(search_execution_id: string, public_device_record_key: string, __ci_system_search_date_key: Date) {
        try {
            const payload =
            {
                search_execution_id,
                public_device_record_key,
                __ci_system_search_date_key,
            };

            const config =
            {
                headers: authHeader(),
            };

            const response = await axios.post(`${API_URL}/api/data-sections/fda/udi/detail`, payload, config);

            return response.data as ResponseSuccessModel;
        } catch (error) {
            return handleAxiosError(error);
        }
    }

}

const fdaApi = new FdaApi();
export default fdaApi;
